<pia3-speechmodel-selector [clientID]="clientID" [selectorMode]="selectorMode" (speechmodelSelected)="_speechmodelSelected($event)"></pia3-speechmodel-selector>
